import { render, staticRenderFns } from "./CommentReactionDialog.vue?vue&type=template&id=11828b75&scoped=true"
import script from "./CommentReactionDialog.vue?vue&type=script&lang=js"
export * from "./CommentReactionDialog.vue?vue&type=script&lang=js"
import style0 from "./CommentReactionDialog.vue?vue&type=style&index=0&id=11828b75&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11828b75",
  null
  
)

export default component.exports